// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"bb67b94c","872":"d5fde726"}[chunkId] + ".chunk.css";
};